import { render, staticRenderFns } from "./stripeRedirectPayment.vue?vue&type=template&id=946318f8&"
import script from "./stripeRedirectPayment.vue?vue&type=script&lang=ts&"
export * from "./stripeRedirectPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports